module.exports = __webpack_public_path__ + "img/5.449c175c.png";